import React, {useEffect, useState} from "react"
import LoadingSpinner from "../spinner/loading.component"
import {FormattedMessage} from "react-intl"
import ActionButton from "../button/actionbutton.component"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend/index"

const ChargeCardIntent = "CHARGE"
const StoreCardIntent = "STORE"
const SandboxScriptURL = "https://sandbox.web.squarecdn.com/v1/square.js"
const ProdScriptURL = "https://web.squarecdn.com/v1/square.js"
declare let window


type OwnProps = {
    children: React.ReactNode
    countryCode: string
    onSubmit: (setupIntent, token, saveCard, error, next) => object
    submitButton: string
    submitButtonStyle: string
    submitDisabled: string
    apiKey: string
    testMode: string
    currency: string
    amount: string
    locationId: string
    saveCard: string
}

type SquarePayment = {
    verifyBuyer(token: string, details: object): Promise<{ token: string }>
}

type SquareCard = {
    tokenize(): Promise<{ nonce: string }>
}

const SquarePayment = (props: OwnProps) => {
    const [card, setCard] = useState<SquareCard>()
    const [payments, setPayments] = useState<SquarePayment>()
    const [loading, setLoading] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [name, setName] = useState("")

    async function initializeCard(payments) {
        const card = await payments.card()
        await card.attach("#card-container")
        setCard(card)
    }

    const initPaymentCard = async () => {
        const square = window.Square
        const payments = square.payments(props.apiKey, props.locationId)
        setPayments(payments)

        try {
            await initializeCard(payments)
        } catch (e) {
            return submitError(e)
        }

        setIsLoaded(true)

    }

    useEffect(() => {
        const script = document.createElement("script")
        script.src = getScriptURL()
        script.type = "text/javascript"
        script.onload = function () {
            void initPaymentCard()
        }
        document.getElementsByTagName("head")[0].appendChild(script)
    }, [])

    const getScriptURL = () =>{
        if (AppContext.getOptions().environment === "prod"){
            return ProdScriptURL
        }
        return SandboxScriptURL
    }

    const submitError = (e) => {
        props.onSubmit(null, null, false, e, disableLoading)
    }

    async function verifyBuyer(token) {
        const verificationDetails = {
            amount: props.amount,
            billingContact: {},
            currencyCode: props.currency,
            intent: props.saveCard ? StoreCardIntent : ChargeCardIntent,
        }

        if (payments) {
            const verificationResults = await payments.verifyBuyer(
                token,
                verificationDetails
            )
            return verificationResults.token
        }
    }

    const disableLoading = () => {
        setLoading(false)
    }

    async function submitHandler() {
        if (name === ""){
            return submitError({message: "One or more of the arguments needed are missing or invalid."})
        }
        if (!card) {
            return submitError({message: "Card is not initialized"})
        }

        setLoading(true)
        let tokenCreationResponse

        try {
            tokenCreationResponse = await card.tokenize()
            if (tokenCreationResponse.status === "Invalid") {
                return submitError(tokenCreationResponse.errors[0])
            }
        } catch (e) {
            return submitError(e)
        }

        let scaResponse
        try {
            scaResponse = await verifyBuyer(tokenCreationResponse.token)
        } catch (e) {
            return submitError(e)
        }

        const token = {
            token: tokenCreationResponse.token,
            verificationToken: scaResponse,
            saveCard: props.saveCard,
            billingDetails: {
                name: name
            }
        }

        props.onSubmit(null, token, props.saveCard, null, disableLoading)
    }

    return (
        <>
            <form id="payment-form">
                {isLoaded ?
                    <div className={"mt-2"}>
                        <FormattedMessage
                            id="common.credit_card.name_label"
                            defaultMessage="Cardholder name"
                        />
                        <input
                            required
                            id="cardholder-name"
                            type="text"
                            className="form-control"
                            onChange={e => {
                                setName(e.target.value)
                            }}
                        />
                        <div className="mt-2">
                            <FormattedMessage
                                id="common.credit_card.card_details_label"
                                defaultMessage="Card details"
                            />
                        </div>
                    </div> : <LoadingSpinner/>
                }

                <div id="card-container"/>

                {isLoaded &&
                    <>
                        {props.children}

                        <div className={"row py-2 mt-2"}>
                            <div
                                className={"pl-4 col-12 col-md-6 d-flex align-items-center justify-content-start flex-wrap mb-2"}>
                                <img src={"/images/credit_cards/1.png"} width={"30px"} className={"mr-1"}/>
                                <img src={"/images/credit_cards/2.png"} width={"30px"} className={"mr-1"}/>
                                <img src={"/images/credit_cards/22.png"} width={"30px"} className={"mr-1"}/>
                            </div>
                            <div className={"col-12 col-md-6"}>
                                <ActionButton
                                    loadingTimeout={30000}
                                    id={"card-button"}
                                    className="btn btn-primary w-100"
                                    style={props.submitButtonStyle}
                                    onClick={submitHandler}
                                    isLoading={loading}
                                    disabled={loading}>
                                    {props.submitButton}
                                </ActionButton>
                            </div>
                        </div>
                    </>
                }
            </form>

            <div id="payment-status-container"/>
        </>
    )
}

export default SquarePayment


// WEBPACK FOOTER //
// ./src/common/credit-card/squareComponent.tsx